import React from 'react'
import DeleteModal from './DeleteModal'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { deleteSection, clearSectionToDelete } from 'modules/knowledgebase/actions'

import { getSectionToDelete } from 'modules/knowledgebase/selectors';

import './style.css'

const DeleteSectionModalContent = ({ onCloseModal, section, actions, isOpen }) => {
  return (
    <DeleteModal
    onCloseModal={() => { 
      onCloseModal()
      actions.clearSectionToDelete()
    }}
    isOpen={isOpen}
    onDelete={() => {
      onCloseModal()
      actions.deleteSection()
    }}
    onCancel={() => {
      onCloseModal()
      actions.clearSectionToDelete()
    }} 
    title={ "Delete Section: " + section.name }
    body={`This section has ${section.documents ? section.documents.length : 0} article(s).
          This section and its contents wil be removed from your knowledgebase.
          Any links that direct to it will no longer work.`}
  />
  )
}

const mapStateToProps = state => ({
  section: getSectionToDelete(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    deleteSection,
    clearSectionToDelete
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSectionModalContent)